import { supabase } from '../lib/supabase';
import type { Json } from '../lib/newDatabase.types';

/**
 * Get public URL for a single image from storage
 */
export async function getImageUrl(storagePath: string): Promise<string | null> {
  try {
    const { data } = supabase
      .storage
      .from('item-images')
      .getPublicUrl(storagePath);

    return data?.publicUrl || null;
  } catch (error) {
    console.error('Error getting image URL:', error);
    return null;
  }
}

/**
 * Get public URLs for multiple images from storage
 */
export async function getImageUrls(storagePaths: string[]): Promise<string[]> {
  try {
    const urls: string[] = [];
    
    for (const path of storagePaths) {
      const url = await getImageUrl(path);
      if (url) {
        urls.push(url);
      }
    }
    
    return urls;
  } catch (error) {
    console.error('Error getting image URLs:', error);
    return [];
  }
}

/**
 * Extract storage paths from images JSON field
 */
export function extractImagePaths(images: Json): string[] {
  try {
    if (!images) return [];
    
    if (Array.isArray(images)) {
      return images.map((img: any) => {
        if (typeof img === 'string') return img;
        if (img && typeof img === 'object' && img.storage_path) {
          return img.storage_path;
        }
        return null;
      }).filter((path): path is string => path !== null);
    }
    
    return [];
  } catch (error) {
    console.error('Error extracting image paths:', error);
    return [];
  }
}

/**
 * Get first image URL from images JSON field
 */
export async function getFirstImageUrl(images: Json): Promise<string | null> {
  const paths = extractImagePaths(images);
  if (paths.length === 0) return null;
  return getImageUrl(paths[0]);
}
